import React, { useState, useRef } from 'react';
import "bootstrap/dist/css/bootstrap.css";
import "./login.scss";
import UsersService from "services/http/users-service";
import logo_ooredoo from "assets/img/logo_ooredoo.png";
import Utils from "utils";
import { InputTextCustomer, CustomButton, ToastNotification, Alert, Input } from 'components/shared';
import { Footer } from 'components/layout';

export const ForgotPassword = () => {
    const [username, setUsername] = useState({ username: null });
    const [loading, setLoading] = useState(false);
    const childRef = useRef();
    const [callbackResp, setCallbackResp] = useState();

    //submit forgot password
    const submitForgotPSWD = (e) => {
        e.preventDefault();
        setLoading(true);
        setCallbackResp(null);
        UsersService.forgotPSWD(username).then(result => {
            setLoading(false);
            childRef?.current?.showToast({
                type: "success",
                title: "Success response",
                durable: false
            });
            setCallbackResp({ icon: "pi pi-check-circle", type: "success", content: result.result });
        }, error => {
            setLoading(false);
            childRef?.current?.showToast({
                type: "warn",
                title: "Error response",
                message: error, durable: false
            });
        });
    }

    return (
        <div className="container">
            <div style={{ padding: "70px 250px 6px" }}>
                <div className="justify-content-center">
                    <div className="justify-content-center">
                        <div className="brand text-center my-4">
                            <img src={logo_ooredoo} alt="Ooredoo" width={"50%"} />
                        </div>
                        <div className="card">
                            <div className="card-body">
                                <h4 className="card-title text-center">Please enter your username in the field below!</h4>
                                <form onSubmit={submitForgotPSWD}>
                                    <Input
                                        id="username"
                                        required
                                        onChange={e => { setUsername({ username: e.target.value }) }}
                                        type="text"
                                        placeholder='Username'
                                        parentClass="my-4"
                                        icon="pi pi-user"
                                    />
                                    <CustomButton
                                        type="submit"
                                        label={Utils.labelTemplate(
                                            <>
                                                <i className="bi bi-check-circle" /> Submit
                                            </>,
                                            loading,
                                            "Loading..."
                                        )}
                                        className="btn btn-primary btn-block"
                                    />
                                    {
                                        callbackResp && <Alert {...callbackResp} />
                                    } 
                                </form>
                                <ToastNotification ref={childRef} />
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>
        </div>
    );

}